<ng-container *ngIf="isAuthenticated">
  <a
    *ngIf="routeLink"
    [class.inverted]="inverted"
    [routerLink]="routeLink"
    angulartics2On="click"
    angularticsAction="home-item-navigate"
    angularticsCategory="home"
    angularticsLabel="{{ actionLabel }}"
    class="home-item"
  >
    <div class="icon">
      <i [class]="'pbi-icon-outline ' + iconClass + ' x2'"></i>
    </div>
    <div>
      <h3>{{ name }}</h3>
      {{ subheading }}
    </div>
  </a>
  <a
    *ngIf="uri"
    [class.inverted]="inverted"
    [href]="uri"
    angulartics2On="click"
    angularticsAction="home-item-navigate"
    angularticsCategory="home"
    angularticsLabel="{{ actionLabel }}"
    class="home-item"
    target="_blank"
  >
    <div class="icon">
      <i [class]="'pbi-icon-outline ' + iconClass + ' x2'"></i>
    </div>
    <div>
      <h3>{{ name }}</h3>
      {{ subheading }}
    </div>
  </a>
</ng-container>

<ng-container *ngIf="!isAuthenticated">
  <a
    *ngIf="routeLink"
    [class.inverted]="inverted"
    [href]="routeLink"
    angulartics2On="click"
    angularticsAction="home-item-navigate"
    angularticsCategory="home"
    angularticsLabel="{{ actionLabel }}"
    class="home-item"
  >
    <div class="icon">
      <i [class]="'pbi-icon-outline ' + iconClass + ' x2'"></i>
    </div>
    <div>
      <h3>{{ name }}</h3>
      {{ subheading }}
    </div>
  </a>
  <a
    *ngIf="uri"
    [class.inverted]="inverted"
    [href]="uri"
    angulartics2On="click"
    angularticsAction="home-item-navigate"
    angularticsCategory="home"
    angularticsLabel="{{ actionLabel }}"
    class="home-item"
    target="_blank"
  >
    <div class="icon">
      <i [class]="'pbi-icon-outline ' + iconClass + ' x2'"></i>
    </div>
    <div>
      <h3>{{ name }}</h3>
      {{ subheading }}
    </div>
  </a>
</ng-container>
